<mat-list>
  @for (app of apps; track app.id; let last = $last) {
    <mat-list-item lines="2">
      <glxy-avatar [src]="app.iconUrl" matListItemIcon></glxy-avatar>
      <span matListItemTitle>{{ getAppDisplayName(app) }}</span>
      <a target="_blank" [routerLink]="app.configurationUrl">{{ 'APPLICATION_SETTINGS' | translate }}</a>

      @if (!hideRemove) {
        <span class="remove-container" matListItemMeta>
          <mat-icon class="clickable" (click)="clickRemove(app)">close</mat-icon>
        </span>
      }
    </mat-list-item>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  }
</mat-list>
